import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './White_Btn.css'

const White_Btn = (props) => {
    return (
        <button className="White_Btn" onClick={props?.onClick} type='button'>
            {props?.icon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.icon} className='icon' />
                </div>
            )}
            <p className='btn_text'>{props?.btn_name}</p>
        </button>
    )
}

export default White_Btn
